import * as React from 'react';
import { Image } from './elements';

type Props = {
  readonly className?: string;
  readonly icon: string;
  readonly alt?: string;
  readonly onClick?: () => void;
};

function Act24(props: Props): React.ReactElement {
  return (
    <Image
      className={props.className}
      src={props.icon}
      alt={props.alt}
      onClick={props.onClick}
      height={24}
      width={24}
    />
  );
}

export default Act24;
